 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}
 		if(executeModules) {
 			for(i=0; i < executeModules.length; i++) {
 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
 			}
 		}
 		return result;
 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		124: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = "text/javascript";
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "js/" + ({"0":"Spinner","2":"Hero","3":"Carousel","4":"LoadMore","5":"LiveStat","6":"OfferCard","7":"GameCardComing","8":"Rating","9":"GameTypeLabels","10":"GameCardSm","11":"GameCard","12":"FiltersToolbar","13":"IconSignal","14":"HeroFeaturedGame","15":"GameCardMd","16":"CasinoStatsList","17":"CasinoInfoList","18":"GameCardSimple","19":"GamesPlay","20":"Profile","21":"OfferBadges","22":"InsightCard","23":"IconPlayed","24":"Featured","25":"FavouriteSupplier","26":"FavouriteCasino","27":"Map","28":"Home","29":"ProfileNav","30":"SupplierGameFilters","31":"ModalFilters","32":"MapWorld","33":"CasinoFeed","34":"NotFound","35":"Casinos","36":"Countdown","37":"NewsArticle","38":"TermsAndConditions1","39":"PrivacyPolicy1","40":"TermsAndConditions0","41":"PrivacyPolicy0","42":"UserFavouriteSuppliers","43":"UserFavouriteOffers","44":"UserFavouriteGames","45":"UserFavouriteCasinos","46":"User","47":"Suppliers","48":"SupplierMobile","49":"Offers","50":"OfferMobile","51":"News","52":"Games","53":"CasinoMobile","54":"StatCircle","55":"OfferCardMd","56":"ModalVideo","57":"InsightSlide","58":"IconTime","59":"FavouritesNavMobile","60":"Expandable","61":"CasinoLocations","62":"CasinoImages","63":"FavouriteOffer","73":"FavouriteGame","74":"GameTypeIcon","75":"Favourite","76":"CasinoSign","78":"UserFavourites","79":"Dropdown","80":"ButtonToggle","82":"Drone","83":"OffersBuilding","84":"GameFilters","85":"NewsCard","86":"CountdownStamp","87":"SupplierCard","88":"Timer","89":"SearchResultsList","90":"NewsCardPopular","91":"GameCardComingMd","92":"BrickCasino","93":"BlankCard","95":"CasinoFilters","96":"OfferCardSm","97":"GameLoader","98":"StatusCardSm","99":"CasinoCard","100":"VideoSlots","101":"NewsBuilding","102":"GameError","103":"CasinoCardSimple","104":"Toolbar","105":"Spaceship","106":"ShareToTwitter","107":"ShareToFacebook","108":"SearchExpand","109":"Pager","110":"OrderedList","111":"OffersCallout","112":"HeroBanner","113":"GamesCta","114":"GameMobile","115":"GameDesktop","116":"GameApiLoader","117":"FeaturedGameCard","118":"Docket","119":"ChooseCasino","120":"CasinoTypes","121":"CasinoProfileDocket","122":"Brick","123":"NewsGrid"}[chunkId]||chunkId) + "." + {"0":"045e91","1":"a50bf5","2":"2eeac7","3":"198b30","4":"d6612c","5":"433756","6":"13b579","7":"77c71e","8":"566c7c","9":"26f298","10":"23aea0","11":"79979b","12":"3b22bd","13":"2e86d6","14":"f653ec","15":"279a02","16":"c2509e","17":"e53738","18":"52aca1","19":"aa1362","20":"4e27dd","21":"cad803","22":"0b5c96","23":"2a8a61","24":"ad6fb3","25":"5261fe","26":"b248a7","27":"3cd3fa","28":"a2ecbd","29":"8abed2","30":"117143","31":"2f6a54","32":"e67e7d","33":"c792c0","34":"4dc299","35":"5f5b23","36":"ee7269","37":"0b17ce","38":"b4e9d2","39":"c51561","40":"fe453e","41":"e6008d","42":"ea12fa","43":"16dee7","44":"125b9f","45":"b14383","46":"d21dbe","47":"a7ea3f","48":"4ded04","49":"c6d88d","50":"d9e082","51":"931a25","52":"a2b499","53":"3e63b5","54":"e69f2f","55":"a7848f","56":"b45712","57":"350ea9","58":"ecdbef","59":"4a19aa","60":"737909","61":"9b5c7d","62":"67e1e9","63":"9958af","70":"747c4b","71":"309f70","72":"b3fb56","73":"33a6c5","74":"2d3490","75":"2c5a11","76":"065c67","77":"4636f0","78":"dc7e03","79":"e14e74","80":"1455a5","81":"95dac5","82":"96e151","83":"d7946b","84":"b723a7","85":"6cb8b8","86":"ca87cf","87":"afcbe3","88":"dde3d5","89":"d20733","90":"646893","91":"e7723b","92":"037008","93":"0215ad","94":"e21e42","95":"5468d3","96":"84ba46","97":"4585a7","98":"a498b1","99":"cbd241","100":"291f1b","101":"8f6269","102":"fc3d83","103":"10a001","104":"b3423b","105":"4c02b0","106":"5b5f77","107":"dd6967","108":"d1b3a5","109":"24f36c","110":"712ab8","111":"f17f1d","112":"07b31f","113":"d9aa46","114":"3e7187","115":"987025","116":"e36367","117":"56f350","118":"54ef07","119":"e5f718","120":"555249","121":"3e0ab2","122":"92fb90","123":"bb2c09"}[chunkId] + ".js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };



// WEBPACK FOOTER //
// webpack/bootstrap 91be8e39ba2846c006c4